import { compareDesc } from 'date-fns';
import { getOfferKey } from 'pages/candidateOffer';
import { Offer, OfferType } from 'pages/candidateOffer/types';

import { ListOffer, ProcessedListOffer } from '../types';

export function compareProcessedOffers(a: ProcessedListOffer, b: ProcessedListOffer) {
    if (a.status === b.status) {
        const offeredDateA = new Date(a.dateOfferedUtc);
        const offeredDateB = new Date(b.dateOfferedUtc);

        return compareDesc(offeredDateA, offeredDateB);
    }

    if (a.status === 'applied') {
        return -1;
    }

    return 1;
}

export function getOfferCustomer(offer: ListOffer): string | undefined {
    const { customer: customerArg, department: departmentArg } = offer;

    const customer = customerArg?.trim();
    const department = departmentArg?.trim();

    if (!customer && !department) {
        return undefined;
    }

    if (department) {
        return `${ customer }, ${ department }`;
    }

    return customer;
}

type OfferToken = string;

export function getInitialPreviewRefMap(offers: ListOffer[]): Record<OfferToken, HTMLDivElement | null> {
    return offers.reduce<Record<OfferToken, HTMLDivElement | null>>((acc, offer) => {
        return {
            ...acc,
            [getOfferKey(offer.orderId, offer.orderRoleId)]: null
        };
    }, {});
}

type ComparableOffer<T> = T & {
    orderId: string;
    orderRoleId: string;
};

export function isSameOffer<T, K>(a: ComparableOffer<T>, b: ComparableOffer<K>) {
    return a.orderId === b.orderId && a.orderRoleId === b.orderRoleId;
}

export function offerToListOffer(offer: ListOffer | Offer): ListOffer {
    if ('offerType' in offer) {
        return offer;
    }

    const offerType: OfferType = offer.shifts?.length ? 'Shifts' : 'Weeks';
    const items = offerType === 'Shifts' ? (offer.shifts ?? []) : (offer.periods ?? []);
    const startTimes = items.map((item) => new Date(item.start).getTime());
    const finishTimes = items.map((item) => new Date(item.finish).getTime());

    return {
        orderId: offer.id,
        orderRoleId: offer.orderRoleId,
        role: offer.role,
        customer: offer.customer,
        department: offer.department,
        location: offer.location,
        dateStartUtc: startTimes.length ? new Date(Math.min(...startTimes)).toISOString() : '',
        dateEndUtc: finishTimes.length ? new Date(Math.max(...finishTimes)).toISOString() : '',
        dateOfferedUtc: offer.dateTimeReceived,
        informationForCandidate: offer.informationForCandidates,
        offerType,
        elementsCount: items.length,
        detailsVisibility: offer.detailsVisibility
    };
}
